import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { NzModalService } from 'ng-zorro-antd/modal';
import { TranslateService } from '@ngx-translate/core';
import { ContactUpsertModalComponent } from './contact-upsert-modal.component';
import { ContactUpsertModalData, ContactUpsertModalResult } from './contact-upsert-modal.types';

@Injectable({
  providedIn: 'root'
})
export class ContactUpsertModalService {
  constructor(
    private modal: NzModalService,
    private translate: TranslateService
  ) {}

  open(data: ContactUpsertModalData): Observable<ContactUpsertModalResult | null> {
    const titleKey = data.contact ? 'CONTACTS.EDIT_CONTACT' : `CONTACTS.ADD_${data.type.toUpperCase()}`;
    const modalRef = this.modal.create<ContactUpsertModalComponent, ContactUpsertModalData, ContactUpsertModalResult | null>({
      nzContent: ContactUpsertModalComponent,
      nzData: data,
      nzTitle: this.translate.instant(titleKey),
      nzFooter: null,
      nzWidth: 640,
      nzMaskClosable: false,
    });

    return modalRef.afterClose.pipe(map((result) => result ?? null));
  }
}
